import type { ErrorInfo } from 'react';

/**
 * Production error reporting stub.
 * Wire-ready: replace body with your SDK call, e.g.:
 *   Sentry.captureException(error, { extra: { componentStack: info.componentStack } })
 */
export function reportError(error: Error, info: ErrorInfo): void {
  if (import.meta.env.DEV) return; // DEV logging handled by ErrorBoundary before this call
  const payload = {
    message: error.message,
    stack: error.stack,
    componentStack: info.componentStack,
    url: window.location.href,
  };
  // eslint-disable-next-line no-console
  console.error('[error-tracking]', payload);
}
